export class Environment {
  public static SELECTED = import.meta.env.PMS_FE_ENV

  public static PRODUCTION = 'prod'
  public static STAGING = 'stg'
  public static TESTING = 'test'
  public static DEVELOPMENT = 'dev'

  public static isEnvProduction = (): boolean => {
    return this.SELECTED === this.PRODUCTION
  }

  public static isEnvLikeProduction = (): boolean => {
    return this.SELECTED === this.PRODUCTION || this.SELECTED === this.STAGING
  }

  public static isEnvDevelopment = (): boolean => {
    return this.SELECTED === this.DEVELOPMENT
  }

  public static isEnvLikeDevelopment = (): boolean => {
    return (
      this.SELECTED === this.STAGING ||
      this.SELECTED === this.TESTING ||
      this.SELECTED === this.DEVELOPMENT
    )
  }
}
